import React from "react";
import { Formik } from "formik";
import Grid from "@material-ui/core/Grid";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";

export const RequestStatesFilterForm = ({
  onChange,
  filterDateRequestStates,
  countRequestStates,
}) => (
  <div class="statistics-form statistics-form_data">
    <Formik
      initialValues={{
        date_since: moment().format("YYYY-MM-DD"),
        date_until: moment().format("YYYY-MM-DD"),
      }}
      validateOnChange={true}
      validateOnBlur={true}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          JSON.stringify(values, null, 2);
          filterDateRequestStates(values);
          countRequestStates(values);
          setSubmitting(false);
        }, 400);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        handleInputChange,
      }) => (
        <Grid item md={12}>
          <form onSubmit={handleSubmit}>
            <div class="form-inline form-group mt-4 mb-4 justify-content-center">
              <div>
                <span class="pt-2 pb-2 pr-2">Desde</span>
                <input
                  class="form-control mb-1 p-2"
                  name="date_since"
                  type="date"
                  required
                  margin="normal"
                  onChange={handleChange}
                  component={DatePicker}
                  value={values.date_since}
                />
              </div>
              <div>
                <span class="p-2">até</span>
                <input
                  class="form-control mb-1 p-2"
                  name="date_until"
                  type="date"
                  required
                  margin="normal"
                  onChange={handleChange}
                  component={DatePicker}
                  value={values.date_until}
                />
              </div>
            </div>
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-primary"
                disabled={isSubmitting}
              >
                Filtrar
              </button>
            </div>
          </form>
        </Grid>
      )}
    </Formik>
  </div>
);
